module.exports = __webpack_public_path__ + "img/filetype_others.02705c6d.png";